import { AdminSpirisProfileStatus } from '../../../services/api';

export type SpirisConnectionFlash = {
  severity: 'success' | 'error';
  message: string;
};

const CALLBACK_ERROR_MESSAGES: Record<string, string> = {
  missing_code: 'Spiris-inloggningen kunde inte slutföras. Försök igen.',
  missing_state: 'Spiris-inloggningen kunde inte verifieras. Försök igen.',
  invalid_state: 'Spiris-inloggningen kunde inte verifieras. Försök igen.',
  expired_state: 'Spiris-inloggningen tog för lång tid. Försök igen.',
  missing_profile: 'Spiris-kopplingen saknar giltig profilinformation.',
  unknown_profile: 'Den valda profilen är inte tillåten för Spiris-koppling.',
  token_exchange_failed: 'Det gick inte att slutföra Spiris-inloggningen. Försök igen.',
  verify_company_failed: 'Det gick inte att verifiera bolaget i Spiris.',
  orgnr_mismatch: 'Fel bolag kopplades till profilen. Koppla om med rätt bolag.',
  token_store_failed: 'Kopplingen kunde inte sparas. Försök igen eller kontakta admin.',
};

export const normalizeSpirisConnectionStatus = (value?: string) => (value || 'unknown').toLowerCase();

export const getSpirisConnectionErrorText = (message?: string) => (message || '').trim();

export const isSpirisConnectionRefreshExpired = (profile: AdminSpirisProfileStatus) => {
  if (!profile.refreshTokenExpiresAt) {
    return false;
  }

  const expiryDate = new Date(profile.refreshTokenExpiresAt);
  if (Number.isNaN(expiryDate.getTime())) {
    return false;
  }

  return expiryDate.getTime() < Date.now();
};

export const readSpirisConnectionCallbackFlash = (): SpirisConnectionFlash | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  const marker = (params.get('spirisConnect') || '').toLowerCase();
  if (!marker) {
    return null;
  }

  const profileKey = params.get('profileKey') || '';
  const errorCode = (params.get('error') || '').trim().toLowerCase();
  const profileSuffix = profileKey ? ` (${profileKey})` : '';

  window.history.replaceState({}, document.title, window.location.pathname);

  if (marker === 'success') {
    return {
      severity: 'success',
      message: `Spiris kopplat${profileSuffix}.`,
    };
  }

  return {
    severity: 'error',
    message: `${CALLBACK_ERROR_MESSAGES[errorCode] || 'Ett okänt Spiris-fel inträffade.'}${profileSuffix}.`,
  };
};